module.exports = __webpack_public_path__ + "static/Sailec_Regular-65bd2b9a3db0ca127825e321c97b6970.woff";